<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pPBrKG/tc-custom/9781625851611.jpg?1702529786969" alt="This image is the cover for the book Seneca County and the Civil War, Civil War Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Seneca County and the Civil War, Civil War Series
      </h1>
      <p class="bookDescription body article font2">
        <p>Though hundreds of miles away from the death and destruction of the battlefield, Seneca County, New York, contributed more than its share for the preservation of the Union. Many brave men left home to fight, suffering hardships and casualties. John Hoster was captured in 1864 and held at the infamous Andersonville prison camp, and his journal has provided invaluable insight into what soldiers held there endured. At home, Seneca farmers fed Lincoln's hungry army, and the legend of the Scythe Tree is a reminder of those who never returned from battle. After the war, Waterloo's celebration in remembrance of fallen soldiers was mimicked around the country, and Waterloo is recognized as the official birthplace of Memorial Day. Local historian Walter Gable recounts the remarkable story of Seneca County during the Civil War.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Walter Gable
      </h2>
      
      <p class="authorDescription body article">Walter Gable has been the Seneca County historian since 2003. He is a graduate of Romulus Central School District and earned his bachelor's and master's degrees at Syracuse University. He taught high school social studies for thirty years in the Seneca Falls Central School District. He was president of the New York State Council for the Social Studies (1997, 98) and recognized as Distinguished Social Studies Educator in New York State in 2000. He received the Seneca Falls Community Service Award in 2013.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6396d1a7